export default [
  [
    require('./LISTEN_AND_SORT/Exercise2.json'),
    require('./LISTEN_AND_SELECT_TONE/Exercise11.json'),
    require('./REVIEW_EXERCISE/index.json'),
    require('./LISTEN_AND_PICK/Exercise31.json'),
    require('./LISTEN_AND_TYPE/Exercise33.json'),
  ]
]